export default __webpack_public_path__ + "static/media/next.064b8c14.svg";